/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../../utils/config';

export const ROUTER_IP_ADDRESS_URL = `${API_URL}/routerIpAddress`;
